/**
* Do not edit directly
* Generated on Wed, 29 Oct 2025 07:42:25 GMT
*/
module.exports = {
  border: {
    border1: '1px',
    border2: '2px',
    border3: '3px',
    border4: '4px',
    none: '0px'
  },
  color: {
    amber: '#faca69',
    amberDark: '#c77539',
    amberLight: '#fff9ee',
    bgModal: 'rgba(244, 244, 247, 0.97)',
    black: '#000000',
    brandLight: '#efedff',
    dark10: 'rgba(0, 0, 0, 0.1)',
    dark20: 'rgba(0, 0, 0, 0.2)',
    dark40: 'rgba(0, 0, 0, 0.4)',
    dark5: 'rgba(0, 0, 0, 0.05)',
    dark60: 'rgba(0, 0, 0, 0.6)',
    dark80: 'rgba(0, 0, 0, 0.8)',
    dark97: 'rgba(0, 0, 0, 0.97)',
    greenAccessible: '#2b8000',
    greenDarkFern: '#163e06',
    greenPanache: '#f4f9f2',
    greenSanFelix: '#1f5c09',
    greenTelus: '#66cc00',
    greenTusk: '#e3f6d1',
    greenYellow: '#bfe797',
    greyAlabaster: '#fafafa',
    greyAthens: '#f4f4f7',
    greyCharcoal: '#414547',
    greyCloud: '#b2b9bf',
    greyLight: '#fafafa',
    greyMystic: '#e3e6e8',
    greyShuttle: '#676e73',
    greyThunder: '#2c2e30',
    light10: 'rgba(255, 255, 255, 0.1)',
    light20: 'rgba(255, 255, 255, 0.2)',
    light40: 'rgba(255, 255, 255, 0.4)',
    light60: 'rgba(255, 255, 255, 0.6)',
    light80: 'rgba(255, 255, 255, 0.8)',
    light97: 'rgba(255, 255, 255, 0.97)',
    purpleDark: '#3f2a54',
    purpleDeluge: '#7c53a5',
    purpleEminence: '#613889',
    purpleLight: '#efedff',
    purpleTelus: '#4b286d',
    red: '#e12339',
    redDark: '#c12335',
    redDarker: '#560c0c',
    redLight: '#fff6f8',
    transparent: 'rgba(0, 0, 0, 0)',
    white: '#ffffff'
  },
  duration: {
    duration250: 250,
    duration300: 300
  },
  font: {
    HNforTELUSSA: {
      300: 'https://cdn.telus.digital/uds/HNforTELUSSADisplay_normal_normal-v5_12_0.woff',
      400: 'https://cdn.telus.digital/uds/HNforTELUSSARegular_normal_normal-v5_12_0.woff',
      500: 'https://cdn.telus.digital/uds/HNforTELUSSAMedium_normal_normal-v5_12_0.woff',
      700: 'https://cdn.telus.digital/uds/HNforTELUSSABold_normal_normal-v5_12_0.woff'
    },
    HNforTELUSSAOTF: {
      300: 'https://cdn.telus.digital/uds/HNforTELUSSA-Display-v5_12_0.otf',
      400: 'https://cdn.telus.digital/uds/HNforTELUSSA-v5_12_0.otf',
      500: 'https://cdn.telus.digital/uds/HNforTELUSSA-Md-v5_12_0.otf',
      700: 'https://cdn.telus.digital/uds/HNforTELUSSA-Bd-v5_12_0.otf'
    },
    HNforTELUSSAWoff2: {
      300: 'https://cdn.telus.digital/uds/HNforTELUSSADisplay_normal_normal2-v5_12_0.woff2',
      400: 'https://cdn.telus.digital/uds/HNforTELUSSARegular_normal_normal2-v5_12_0.woff2',
      500: 'https://cdn.telus.digital/uds/HNforTELUSSAMedium_normal_normal2-v5_12_0.woff2',
      700: 'https://cdn.telus.digital/uds/HNforTELUSSABold_normal_normal2-v5_12_0.woff2'
    }
  },
  fontSize: {
    size12: '0.75rem',
    size14: '0.875rem',
    size16: '1rem',
    size20: '1.25rem',
    size24: '1.5rem',
    size28: '1.75rem',
    size32: '2rem',
    size36: '2.25rem',
    size40: '2.5rem',
    size56: '3.5rem',
    size64: '4rem'
  },
  gradient: {
    base: 'radial-gradient(44.58% 44.58% at 81.13% 36.79%, #ffffff 0%, #f4f4f7 100%)',
    brand: 'linear-gradient(135deg, #4b286d, 75%, #613889)',
    green: 'linear-gradient(135deg, #00784a, 75%, #66cc00)',
    neutral: 'linear-gradient(180deg, #ffffff, #f4f4f7)',
    purple: 'linear-gradient(135deg, #4b286d, 75%, #e53293)'
  },
  icon: {
    AC: '@telus-uds/palette-allium/build/web/icons/ac.icon.svg',
    Accessible: '@telus-uds/palette-allium/build/web/icons/accessible.icon.svg',
    AccessibleHuman: '@telus-uds/palette-allium/build/web/icons/accessible-human.icon.svg',
    Add: '@telus-uds/palette-allium/build/web/icons/add.icon.svg',
    AddUser: '@telus-uds/palette-allium/build/web/icons/add-user.icon.svg',
    Airplane: '@telus-uds/palette-allium/build/web/icons/airplane.icon.svg',
    AirplaneBold: '@telus-uds/palette-allium/build/web/icons/airplane-bold.icon.svg',
    AlarmClock: '@telus-uds/palette-allium/build/web/icons/alarm-clock.icon.svg',
    Ambulance: '@telus-uds/palette-allium/build/web/icons/ambulance.icon.svg',
    Amex: '@telus-uds/palette-allium/build/web/icons/amex.icon.svg',
    AndroidEN: '@telus-uds/palette-allium/build/web/icons/android-en.icon.svg',
    AndroidFR: '@telus-uds/palette-allium/build/web/icons/android-fr.icon.svg',
    ArrowDown: '@telus-uds/palette-allium/build/web/icons/arrow-down.icon.svg',
    ArrowLeft: '@telus-uds/palette-allium/build/web/icons/arrow-left.icon.svg',
    ArrowRight: '@telus-uds/palette-allium/build/web/icons/arrow-right.icon.svg',
    ArrowUp: '@telus-uds/palette-allium/build/web/icons/arrow-up.icon.svg',
    ArtificialIntelligence: '@telus-uds/palette-allium/build/web/icons/artificial-intelligence.icon.svg',
    AssistiveListening: '@telus-uds/palette-allium/build/web/icons/assistive-listening.icon.svg',
    Attention: '@telus-uds/palette-allium/build/web/icons/attention.icon.svg',
    Award: '@telus-uds/palette-allium/build/web/icons/award.icon.svg',
    Baby: '@telus-uds/palette-allium/build/web/icons/baby.icon.svg',
    BabyBoy: '@telus-uds/palette-allium/build/web/icons/baby-boy.icon.svg',
    BabyGirl: '@telus-uds/palette-allium/build/web/icons/baby-girl.icon.svg',
    BackToSchool: '@telus-uds/palette-allium/build/web/icons/back-to-school.icon.svg',
    Bank: '@telus-uds/palette-allium/build/web/icons/bank.icon.svg',
    BasketBold: '@telus-uds/palette-allium/build/web/icons/basket-bold.icon.svg',
    BasketSolid: '@telus-uds/palette-allium/build/web/icons/basket-solid.icon.svg',
    BatteryCar: '@telus-uds/palette-allium/build/web/icons/battery-car.icon.svg',
    BatteryCharging: '@telus-uds/palette-allium/build/web/icons/battery-charging.icon.svg',
    Bell: '@telus-uds/palette-allium/build/web/icons/bell.icon.svg',
    Bill: '@telus-uds/palette-allium/build/web/icons/bill.icon.svg',
    BillingBold: '@telus-uds/palette-allium/build/web/icons/billing-bold.icon.svg',
    BillingSearchBold: '@telus-uds/palette-allium/build/web/icons/billing-search-bold.icon.svg',
    BillingSolid: '@telus-uds/palette-allium/build/web/icons/billing-solid.icon.svg',
    Bookmark: '@telus-uds/palette-allium/build/web/icons/bookmark.icon.svg',
    Braille: '@telus-uds/palette-allium/build/web/icons/braille.icon.svg',
    Briefcase: '@telus-uds/palette-allium/build/web/icons/briefcase.icon.svg',
    BulletCircle: '@telus-uds/palette-allium/build/web/icons/bullet-circle.icon.svg',
    BulletFill: '@telus-uds/palette-allium/build/web/icons/bullet-fill.icon.svg',
    Calendar: '@telus-uds/palette-allium/build/web/icons/calendar.icon.svg',
    Call: '@telus-uds/palette-allium/build/web/icons/call.icon.svg',
    CallForward: '@telus-uds/palette-allium/build/web/icons/call-forward.icon.svg',
    CallOut: '@telus-uds/palette-allium/build/web/icons/call-out.icon.svg',
    CallReceive: '@telus-uds/palette-allium/build/web/icons/call-receive.icon.svg',
    CallTalking: '@telus-uds/palette-allium/build/web/icons/call-talking.icon.svg',
    Camera: '@telus-uds/palette-allium/build/web/icons/camera.icon.svg',
    CanUs: '@telus-uds/palette-allium/build/web/icons/can-us.icon.svg',
    Car: '@telus-uds/palette-allium/build/web/icons/car.icon.svg',
    CardLightningBold: '@telus-uds/palette-allium/build/web/icons/card-lightning-bold.icon.svg',
    CaretDown: '@telus-uds/palette-allium/build/web/icons/caret-down.icon.svg',
    CaretUp: '@telus-uds/palette-allium/build/web/icons/caret-up.icon.svg',
    CartEmptyBold: '@telus-uds/palette-allium/build/web/icons/cart-empty-bold.icon.svg',
    CartFilledBold: '@telus-uds/palette-allium/build/web/icons/cart-filled-bold.icon.svg',
    Channels: '@telus-uds/palette-allium/build/web/icons/channels.icon.svg',
    ChartsBar1: '@telus-uds/palette-allium/build/web/icons/charts-bar1.icon.svg',
    ChartsBar2: '@telus-uds/palette-allium/build/web/icons/charts-bar2.icon.svg',
    ChartsBar3Bold: '@telus-uds/palette-allium/build/web/icons/charts-bar3-bold.icon.svg',
    ChartsBar3Solid: '@telus-uds/palette-allium/build/web/icons/charts-bar3-solid.icon.svg',
    ChartsLine: '@telus-uds/palette-allium/build/web/icons/charts-line.icon.svg',
    Chat1: '@telus-uds/palette-allium/build/web/icons/chat1.icon.svg',
    Chat2: '@telus-uds/palette-allium/build/web/icons/chat2.icon.svg',
    ChatHappyBold: '@telus-uds/palette-allium/build/web/icons/chat-happy-bold.icon.svg',
    ChatHappySolid: '@telus-uds/palette-allium/build/web/icons/chat-happy-solid.icon.svg',
    ChatSupport: '@telus-uds/palette-allium/build/web/icons/chat-support.icon.svg',
    Check: '@telus-uds/palette-allium/build/web/icons/check.icon.svg',
    Checkbold: '@telus-uds/palette-allium/build/web/icons/checkbold.icon.svg',
    Checkmark: '@telus-uds/palette-allium/build/web/icons/checkmark.icon.svg',
    ChevronLeft: '@telus-uds/palette-allium/build/web/icons/chevron-left.icon.svg',
    ChevronRight: '@telus-uds/palette-allium/build/web/icons/chevron-right.icon.svg',
    Clipboard: '@telus-uds/palette-allium/build/web/icons/clipboard.icon.svg',
    Close: '@telus-uds/palette-allium/build/web/icons/close.icon.svg',
    ClosedCaptions: '@telus-uds/palette-allium/build/web/icons/closed-captions.icon.svg',
    CloudDownload: '@telus-uds/palette-allium/build/web/icons/cloud-download.icon.svg',
    CloudSync: '@telus-uds/palette-allium/build/web/icons/cloud-sync.icon.svg',
    CloudUpload: '@telus-uds/palette-allium/build/web/icons/cloud-upload.icon.svg',
    CognitiveDisability: '@telus-uds/palette-allium/build/web/icons/cognitive-disability.icon.svg',
    Collaboration: '@telus-uds/palette-allium/build/web/icons/collaboration.icon.svg',
    Compass: '@telus-uds/palette-allium/build/web/icons/compass.icon.svg',
    ComputerNetwork: '@telus-uds/palette-allium/build/web/icons/computer-network.icon.svg',
    Contract: '@telus-uds/palette-allium/build/web/icons/contract.icon.svg',
    CopyBold: '@telus-uds/palette-allium/build/web/icons/copy-bold.icon.svg',
    CreditCard: '@telus-uds/palette-allium/build/web/icons/credit-card.icon.svg',
    Cronometer: '@telus-uds/palette-allium/build/web/icons/cronometer.icon.svg',
    CssActivations: '@telus-uds/palette-allium/build/web/icons/css-activations.icon.svg',
    DataLimit: '@telus-uds/palette-allium/build/web/icons/data-limit.icon.svg',
    Deals: '@telus-uds/palette-allium/build/web/icons/deals.icon.svg',
    Delete: '@telus-uds/palette-allium/build/web/icons/delete.icon.svg',
    Delivery: '@telus-uds/palette-allium/build/web/icons/delivery.icon.svg',
    Desk: '@telus-uds/palette-allium/build/web/icons/desk.icon.svg',
    DeviceHand: '@telus-uds/palette-allium/build/web/icons/device-hand.icon.svg',
    Devices: '@telus-uds/palette-allium/build/web/icons/devices.icon.svg',
    Diagram: '@telus-uds/palette-allium/build/web/icons/diagram.icon.svg',
    Diamond: '@telus-uds/palette-allium/build/web/icons/diamond.icon.svg',
    Direction: '@telus-uds/palette-allium/build/web/icons/direction.icon.svg',
    Document: '@telus-uds/palette-allium/build/web/icons/document.icon.svg',
    Donate: '@telus-uds/palette-allium/build/web/icons/donate.icon.svg',
    Download: '@telus-uds/palette-allium/build/web/icons/download.icon.svg',
    DownloadBoldMono: '@telus-uds/palette-allium/build/web/icons/download-bold-mono.icon.svg',
    DownloadPdf: '@telus-uds/palette-allium/build/web/icons/download-pdf.icon.svg',
    DownloadPdfs: '@telus-uds/palette-allium/build/web/icons/download-pdfs.icon.svg',
    EVCharging: '@telus-uds/palette-allium/build/web/icons/evcharging.icon.svg',
    EcoBulb: '@telus-uds/palette-allium/build/web/icons/eco-bulb.icon.svg',
    Edit: '@telus-uds/palette-allium/build/web/icons/edit.icon.svg',
    Email: '@telus-uds/palette-allium/build/web/icons/email.icon.svg',
    Escalations: '@telus-uds/palette-allium/build/web/icons/escalations.icon.svg',
    Expand: '@telus-uds/palette-allium/build/web/icons/expand.icon.svg',
    EyeClosed: '@telus-uds/palette-allium/build/web/icons/eye-closed.icon.svg',
    EyeMasked: '@telus-uds/palette-allium/build/web/icons/eye-masked.icon.svg',
    EyeOpened: '@telus-uds/palette-allium/build/web/icons/eye-opened.icon.svg',
    EyeUnmasked: '@telus-uds/palette-allium/build/web/icons/eye-unmasked.icon.svg',
    FavouriteNetwork: '@telus-uds/palette-allium/build/web/icons/favourite-network.icon.svg',
    Files: '@telus-uds/palette-allium/build/web/icons/files.icon.svg',
    Fingerprint: '@telus-uds/palette-allium/build/web/icons/fingerprint.icon.svg',
    Firewall: '@telus-uds/palette-allium/build/web/icons/firewall.icon.svg',
    Flag: '@telus-uds/palette-allium/build/web/icons/flag.icon.svg',
    FullscreenExpand: '@telus-uds/palette-allium/build/web/icons/fullscreen-expand.icon.svg',
    FullscreenMinimize: '@telus-uds/palette-allium/build/web/icons/fullscreen-minimize.icon.svg',
    Gift: '@telus-uds/palette-allium/build/web/icons/gift.icon.svg',
    Globe1: '@telus-uds/palette-allium/build/web/icons/globe1.icon.svg',
    Globe2: '@telus-uds/palette-allium/build/web/icons/globe2.icon.svg',
    Grid: '@telus-uds/palette-allium/build/web/icons/grid.icon.svg',
    HeadBoth: '@telus-uds/palette-allium/build/web/icons/head-both.icon.svg',
    HeadFemale: '@telus-uds/palette-allium/build/web/icons/head-female.icon.svg',
    HeadMale: '@telus-uds/palette-allium/build/web/icons/head-male.icon.svg',
    Headset: '@telus-uds/palette-allium/build/web/icons/headset.icon.svg',
    Heart: '@telus-uds/palette-allium/build/web/icons/heart.icon.svg',
    Heartbeat: '@telus-uds/palette-allium/build/web/icons/heartbeat.icon.svg',
    Heater: '@telus-uds/palette-allium/build/web/icons/heater.icon.svg',
    Helpdesk: '@telus-uds/palette-allium/build/web/icons/helpdesk.icon.svg',
    Home: '@telus-uds/palette-allium/build/web/icons/home.icon.svg',
    HomePro: '@telus-uds/palette-allium/build/web/icons/home-pro.icon.svg',
    HomeSecurity: '@telus-uds/palette-allium/build/web/icons/home-security.icon.svg',
    HouseBold: '@telus-uds/palette-allium/build/web/icons/house-bold.icon.svg',
    HouseSolid: '@telus-uds/palette-allium/build/web/icons/house-solid.icon.svg',
    HouseSwapBold: '@telus-uds/palette-allium/build/web/icons/house-swap-bold.icon.svg',
    IDTag: '@telus-uds/palette-allium/build/web/icons/idtag.icon.svg',
    IOSEN: '@telus-uds/palette-allium/build/web/icons/iosen.icon.svg',
    IOSFR: '@telus-uds/palette-allium/build/web/icons/iosfr.icon.svg',
    IdCard: '@telus-uds/palette-allium/build/web/icons/id-card.icon.svg',
    Infinite: '@telus-uds/palette-allium/build/web/icons/infinite.icon.svg',
    Information: '@telus-uds/palette-allium/build/web/icons/information.icon.svg',
    Internet: '@telus-uds/palette-allium/build/web/icons/internet.icon.svg',
    InternetAddBold: '@telus-uds/palette-allium/build/web/icons/internet-add-bold.icon.svg',
    Invisible: '@telus-uds/palette-allium/build/web/icons/invisible.icon.svg',
    Key: '@telus-uds/palette-allium/build/web/icons/key.icon.svg',
    Laptop: '@telus-uds/palette-allium/build/web/icons/laptop.icon.svg',
    Layers: '@telus-uds/palette-allium/build/web/icons/layers.icon.svg',
    LeakDetect: '@telus-uds/palette-allium/build/web/icons/leak-detect.icon.svg',
    Lifesaver: '@telus-uds/palette-allium/build/web/icons/lifesaver.icon.svg',
    Lightbulb: '@telus-uds/palette-allium/build/web/icons/lightbulb.icon.svg',
    LinkExternal: '@telus-uds/palette-allium/build/web/icons/link-external.icon.svg',
    List: '@telus-uds/palette-allium/build/web/icons/list.icon.svg',
    LocationAdd: '@telus-uds/palette-allium/build/web/icons/location-add.icon.svg',
    LocationHome: '@telus-uds/palette-allium/build/web/icons/location-home.icon.svg',
    LocationIneligible: '@telus-uds/palette-allium/build/web/icons/location-ineligible.icon.svg',
    LocationMap: '@telus-uds/palette-allium/build/web/icons/location-map.icon.svg',
    LocationRegular: '@telus-uds/palette-allium/build/web/icons/location-regular.icon.svg',
    LocationRemove: '@telus-uds/palette-allium/build/web/icons/location-remove.icon.svg',
    LocationSuccess: '@telus-uds/palette-allium/build/web/icons/location-success.icon.svg',
    LocationVerified: '@telus-uds/palette-allium/build/web/icons/location-verified.icon.svg',
    LockClosed: '@telus-uds/palette-allium/build/web/icons/lock-closed.icon.svg',
    LockOpened: '@telus-uds/palette-allium/build/web/icons/lock-opened.icon.svg',
    LoginForm: '@telus-uds/palette-allium/build/web/icons/login-form.icon.svg',
    Magnify: '@telus-uds/palette-allium/build/web/icons/magnify.icon.svg',
    Map: '@telus-uds/palette-allium/build/web/icons/map.icon.svg',
    MasterCard: '@telus-uds/palette-allium/build/web/icons/master-card.icon.svg',
    Medical: '@telus-uds/palette-allium/build/web/icons/medical.icon.svg',
    MenuHamburger: '@telus-uds/palette-allium/build/web/icons/menu-hamburger.icon.svg',
    Messaging: '@telus-uds/palette-allium/build/web/icons/messaging.icon.svg',
    Microphone: '@telus-uds/palette-allium/build/web/icons/microphone.icon.svg',
    Mobility: '@telus-uds/palette-allium/build/web/icons/mobility.icon.svg',
    Modal: '@telus-uds/palette-allium/build/web/icons/modal.icon.svg',
    Money: '@telus-uds/palette-allium/build/web/icons/money.icon.svg',
    MoneyBack: '@telus-uds/palette-allium/build/web/icons/money-back.icon.svg',
    Movie: '@telus-uds/palette-allium/build/web/icons/movie.icon.svg',
    Music: '@telus-uds/palette-allium/build/web/icons/music.icon.svg',
    Muted: '@telus-uds/palette-allium/build/web/icons/muted.icon.svg',
    Networking: '@telus-uds/palette-allium/build/web/icons/networking.icon.svg',
    News: '@telus-uds/palette-allium/build/web/icons/news.icon.svg',
    NextGenFirewall: '@telus-uds/palette-allium/build/web/icons/next-gen-firewall.icon.svg',
    NoContract: '@telus-uds/palette-allium/build/web/icons/no-contract.icon.svg',
    NotifyBold: '@telus-uds/palette-allium/build/web/icons/notify-bold.icon.svg',
    OffersBold: '@telus-uds/palette-allium/build/web/icons/offers-bold.icon.svg',
    OffersSolid: '@telus-uds/palette-allium/build/web/icons/offers-solid.icon.svg',
    Office: '@telus-uds/palette-allium/build/web/icons/office.icon.svg',
    Offices: '@telus-uds/palette-allium/build/web/icons/offices.icon.svg',
    OnDemand: '@telus-uds/palette-allium/build/web/icons/on-demand.icon.svg',
    OnTheGo: '@telus-uds/palette-allium/build/web/icons/on-the-go.icon.svg',
    OnlineSecurity: '@telus-uds/palette-allium/build/web/icons/online-security.icon.svg',
    OrderAscend: '@telus-uds/palette-allium/build/web/icons/order-ascend.icon.svg',
    OrderDescend: '@telus-uds/palette-allium/build/web/icons/order-descend.icon.svg',
    Paperless: '@telus-uds/palette-allium/build/web/icons/paperless.icon.svg',
    Passport: '@telus-uds/palette-allium/build/web/icons/passport.icon.svg',
    Pause: '@telus-uds/palette-allium/build/web/icons/pause.icon.svg',
    Phone: '@telus-uds/palette-allium/build/web/icons/phone.icon.svg',
    PhoneBusiness: '@telus-uds/palette-allium/build/web/icons/phone-business.icon.svg',
    PhoneHome: '@telus-uds/palette-allium/build/web/icons/phone-home.icon.svg',
    PhoneReception: '@telus-uds/palette-allium/build/web/icons/phone-reception.icon.svg',
    Photo: '@telus-uds/palette-allium/build/web/icons/photo.icon.svg',
    Photos: '@telus-uds/palette-allium/build/web/icons/photos.icon.svg',
    PiggyBank: '@telus-uds/palette-allium/build/web/icons/piggy-bank.icon.svg',
    PikTV: '@telus-uds/palette-allium/build/web/icons/pik-tv.icon.svg',
    Play: '@telus-uds/palette-allium/build/web/icons/play.icon.svg',
    PlaySolid: '@telus-uds/palette-allium/build/web/icons/play-solid.icon.svg',
    PlayVideo: '@telus-uds/palette-allium/build/web/icons/play-video.icon.svg',
    PowerDrill: '@telus-uds/palette-allium/build/web/icons/power-drill.icon.svg',
    Preference: '@telus-uds/palette-allium/build/web/icons/preference.icon.svg',
    Print: '@telus-uds/palette-allium/build/web/icons/print.icon.svg',
    PrivateCloud: '@telus-uds/palette-allium/build/web/icons/private-cloud.icon.svg',
    ProactiveAssurance: '@telus-uds/palette-allium/build/web/icons/proactive-assurance.icon.svg',
    Profile: '@telus-uds/palette-allium/build/web/icons/profile.icon.svg',
    ProfileBold: '@telus-uds/palette-allium/build/web/icons/profile-bold.icon.svg',
    Question: '@telus-uds/palette-allium/build/web/icons/question.icon.svg',
    QuoteLeft: '@telus-uds/palette-allium/build/web/icons/quote-left.icon.svg',
    QuoteLeftArrow: '@telus-uds/palette-allium/build/web/icons/quote-left-arrow.icon.svg',
    QuoteRightArrow: '@telus-uds/palette-allium/build/web/icons/quote-right-arrow.icon.svg',
    Radar: '@telus-uds/palette-allium/build/web/icons/radar.icon.svg',
    Receipt: '@telus-uds/palette-allium/build/web/icons/receipt.icon.svg',
    Record: '@telus-uds/palette-allium/build/web/icons/record.icon.svg',
    Refresh: '@telus-uds/palette-allium/build/web/icons/refresh.icon.svg',
    RemoteControl: '@telus-uds/palette-allium/build/web/icons/remote-control.icon.svg',
    Replay: '@telus-uds/palette-allium/build/web/icons/replay.icon.svg',
    Router: '@telus-uds/palette-allium/build/web/icons/router.icon.svg',
    Search: '@telus-uds/palette-allium/build/web/icons/search.icon.svg',
    SearchBold: '@telus-uds/palette-allium/build/web/icons/search-bold.icon.svg',
    SearchPulseBold: '@telus-uds/palette-allium/build/web/icons/search-pulse-bold.icon.svg',
    SecurityCamera: '@telus-uds/palette-allium/build/web/icons/security-camera.icon.svg',
    SecurityHouse: '@telus-uds/palette-allium/build/web/icons/security-house.icon.svg',
    SecurityMobile: '@telus-uds/palette-allium/build/web/icons/security-mobile.icon.svg',
    SecuritySettings: '@telus-uds/palette-allium/build/web/icons/security-settings.icon.svg',
    Server: '@telus-uds/palette-allium/build/web/icons/server.icon.svg',
    ServiceTruck: '@telus-uds/palette-allium/build/web/icons/service-truck.icon.svg',
    Settings: '@telus-uds/palette-allium/build/web/icons/settings.icon.svg',
    SettingsBold: '@telus-uds/palette-allium/build/web/icons/settings-bold.icon.svg',
    SettingsSolid: '@telus-uds/palette-allium/build/web/icons/settings-solid.icon.svg',
    SharedAccount: '@telus-uds/palette-allium/build/web/icons/shared-account.icon.svg',
    ShippingSuccess: '@telus-uds/palette-allium/build/web/icons/shipping-success.icon.svg',
    Shop: '@telus-uds/palette-allium/build/web/icons/shop.icon.svg',
    SignPost: '@telus-uds/palette-allium/build/web/icons/sign-post.icon.svg',
    Signal: '@telus-uds/palette-allium/build/web/icons/signal.icon.svg',
    SimCard: '@telus-uds/palette-allium/build/web/icons/sim-card.icon.svg',
    SimElectronic: '@telus-uds/palette-allium/build/web/icons/sim-electronic.icon.svg',
    SmartWearSecurity: '@telus-uds/palette-allium/build/web/icons/smart-wear-security.icon.svg',
    Soccer: '@telus-uds/palette-allium/build/web/icons/soccer.icon.svg',
    Speaker: '@telus-uds/palette-allium/build/web/icons/speaker.icon.svg',
    SpeakerPhone: '@telus-uds/palette-allium/build/web/icons/speaker-phone.icon.svg',
    Speed: '@telus-uds/palette-allium/build/web/icons/speed.icon.svg',
    SpeedReduced: '@telus-uds/palette-allium/build/web/icons/speed-reduced.icon.svg',
    SpeedReducedBold: '@telus-uds/palette-allium/build/web/icons/speed-reduced-bold.icon.svg',
    StatusError: '@telus-uds/palette-allium/build/web/icons/status-error.icon.svg',
    StatusInfo: '@telus-uds/palette-allium/build/web/icons/status-info.icon.svg',
    StatusSuccess: '@telus-uds/palette-allium/build/web/icons/status-success.icon.svg',
    StatusWarning: '@telus-uds/palette-allium/build/web/icons/status-warning.icon.svg',
    Subtract: '@telus-uds/palette-allium/build/web/icons/subtract.icon.svg',
    Success: '@telus-uds/palette-allium/build/web/icons/success.icon.svg',
    Suitcase: '@telus-uds/palette-allium/build/web/icons/suitcase.icon.svg',
    Support: '@telus-uds/palette-allium/build/web/icons/support.icon.svg',
    Support911: '@telus-uds/palette-allium/build/web/icons/support911.icon.svg',
    SupportBold: '@telus-uds/palette-allium/build/web/icons/support-bold.icon.svg',
    TV: '@telus-uds/palette-allium/build/web/icons/tv.icon.svg',
    TVChoiceAndFlexibility: '@telus-uds/palette-allium/build/web/icons/tvchoice-and-flexibility.icon.svg',
    TVEntertainment: '@telus-uds/palette-allium/build/web/icons/tventertainment.icon.svg',
    Tablet: '@telus-uds/palette-allium/build/web/icons/tablet.icon.svg',
    Tag: '@telus-uds/palette-allium/build/web/icons/tag.icon.svg',
    TagFilled: '@telus-uds/palette-allium/build/web/icons/tag-filled.icon.svg',
    Target: '@telus-uds/palette-allium/build/web/icons/target.icon.svg',
    Tasks: '@telus-uds/palette-allium/build/web/icons/tasks.icon.svg',
    Teapot: '@telus-uds/palette-allium/build/web/icons/teapot.icon.svg',
    ThumbsDown: '@telus-uds/palette-allium/build/web/icons/thumbs-down.icon.svg',
    ThumbsDownFill: '@telus-uds/palette-allium/build/web/icons/thumbs-down-fill.icon.svg',
    ThumbsUp: '@telus-uds/palette-allium/build/web/icons/thumbs-up.icon.svg',
    ThumbsUpFill: '@telus-uds/palette-allium/build/web/icons/thumbs-up-fill.icon.svg',
    Time: '@telus-uds/palette-allium/build/web/icons/time.icon.svg',
    TimeCycle: '@telus-uds/palette-allium/build/web/icons/time-cycle.icon.svg',
    Times: '@telus-uds/palette-allium/build/web/icons/times.icon.svg',
    TowTruck: '@telus-uds/palette-allium/build/web/icons/tow-truck.icon.svg',
    Transmitter: '@telus-uds/palette-allium/build/web/icons/transmitter.icon.svg',
    TriangleUpTripleBold: '@telus-uds/palette-allium/build/web/icons/triangle-up-triple-bold.icon.svg',
    TvTilesBold: '@telus-uds/palette-allium/build/web/icons/tv-tiles-bold.icon.svg',
    TvTilesFilled: '@telus-uds/palette-allium/build/web/icons/tv-tiles-filled.icon.svg',
    Unmuted: '@telus-uds/palette-allium/build/web/icons/unmuted.icon.svg',
    Upload: '@telus-uds/palette-allium/build/web/icons/upload.icon.svg',
    UploadToCloud: '@telus-uds/palette-allium/build/web/icons/upload-to-cloud.icon.svg',
    UsbCable: '@telus-uds/palette-allium/build/web/icons/usb-cable.icon.svg',
    User: '@telus-uds/palette-allium/build/web/icons/user.icon.svg',
    UserAdd: '@telus-uds/palette-allium/build/web/icons/user-add.icon.svg',
    UserAddBold: '@telus-uds/palette-allium/build/web/icons/user-add-bold.icon.svg',
    Users: '@telus-uds/palette-allium/build/web/icons/users.icon.svg',
    VideoCall: '@telus-uds/palette-allium/build/web/icons/video-call.icon.svg',
    VideoChat: '@telus-uds/palette-allium/build/web/icons/video-chat.icon.svg',
    VideoGames: '@telus-uds/palette-allium/build/web/icons/video-games.icon.svg',
    Visa: '@telus-uds/palette-allium/build/web/icons/visa.icon.svg',
    Visible: '@telus-uds/palette-allium/build/web/icons/visible.icon.svg',
    VisuallyImpaired: '@telus-uds/palette-allium/build/web/icons/visually-impaired.icon.svg',
    Warranty: '@telus-uds/palette-allium/build/web/icons/warranty.icon.svg',
    WarrantyBold: '@telus-uds/palette-allium/build/web/icons/warranty-bold.icon.svg',
    Watch: '@telus-uds/palette-allium/build/web/icons/watch.icon.svg',
    WaterProhibited: '@telus-uds/palette-allium/build/web/icons/water-prohibited.icon.svg',
    WebStore: '@telus-uds/palette-allium/build/web/icons/web-store.icon.svg',
    WifiBoost: '@telus-uds/palette-allium/build/web/icons/wifi-boost.icon.svg',
    WifiCloud: '@telus-uds/palette-allium/build/web/icons/wifi-cloud.icon.svg'
  },
  letterSpacing: {
    condensed: -0.039,
    loose: -0.017,
    medium: -0.035
  },
  lineHeight: {
    ratio10to5: 1.95,
    ratio10to7: 1.42857142857,
    ratio11to9: 1.22222222222,
    ratio14to1: 1.45,
    ratio15to7: 2.12,
    ratio1to1: 1,
    ratio2to1: 2,
    ratio3to2: 1.5,
    ratio4to3: 1.33333333333,
    ratio5to4: 1.25,
    ratio6to5: 1.2,
    ratio7to5: 1.4,
    ratio8to5: 1.6,
    ratio8to7: 1.14285714286,
    ratio9to4: 2.25,
    ratio9to7: 1.28571428571,
    ratio9to8: 1.125
  },
  opacity: {
    opacity10: 1
  },
  radius: {
    none: '0px',
    pill32: '32px',
    radius1: '1px',
    radius12: '12px',
    radius16: '16px',
    radius24: '24px',
    radius28: '28px',
    radius32: '32px',
    radius4: '4px',
    radius45: '45px',
    radius6: '6px',
    radius8: '8px',
    radius99: '99px'
  },
  shadow: {
    elevation1: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
    elevation2: '0px 12px 12px 0px rgba(0, 0, 0, 0.03)',
    elevation3: '0px 32px 32px 0px rgba(0, 0, 0, 0.03)',
    surfaceEmboss: '0px 1px 1px 0px inset rgba(255, 255, 255, 0.8)',
    surfaceInset: '0px 2px 2px 0px inset rgba(0, 0, 0, 0.1)',
    surfaceRaised: '0px 2px 2px 0px rgba(0, 0, 0, 0.2)'
  },
  size: {
    size0: '0px',
    size1: '1px',
    size10: '10px',
    size12: '12px',
    size120: '120px',
    size128: '128px',
    size13: '13px',
    size14: '14px',
    size140: '140px',
    size144: '144px',
    size15: '15px',
    size16: '16px',
    size162: '162px',
    size168: '168px',
    size18: '18px',
    size184: '184px',
    size192: '192px',
    size2: '2px',
    size20: '20px',
    size21: '21px',
    size22: '22px',
    size24: '24px',
    size26: '26px',
    size264: '264px',
    size28: '28px',
    size288: '288px',
    size29: '29px',
    size3: '3px',
    size32: '32px',
    size320: '320px',
    size35: '35px',
    size36: '36px',
    size4: '4px',
    size40: '40px',
    size412: '412px',
    size44: '44px',
    size45: '45px',
    size48: '48px',
    size480: '480px',
    size5: '5px',
    size52: '52px',
    size53: '53px',
    size544: '544px',
    size56: '56px',
    size576: '576px',
    size6: '6px',
    size630: '630px',
    size64: '64px',
    size640: '640px',
    size72: '72px',
    size768: '768px',
    size8: '8px',
    size80: '80px',
    size91: '91px',
    size95: '95px',
    size96: '96px'
  }
}
